import React from "react";

type ResetPasswordContainerProps = React.ComponentProps<"div">;

export const ResetPasswordWrapper = ({
  children,
}: ResetPasswordContainerProps) => {
  return (
    <form className={"h-[39rem]"} onSubmit={(e) => e.preventDefault()}>
      {children}
    </form>
  );
};
